import { ActionEnum } from '@common/graphql/operations';
import { computed } from 'vue';
export var useGetNotificationIcon = function (notificationAction) {
    var statusIcon = computed(function () {
        if ([
            ActionEnum.ActionHomeworkStudentSent,
            ActionEnum.ActionHomeworksStudentsSentCron,
            ActionEnum.ActionHomeworkTeacherSent,
            ActionEnum.ActionHomeworksTeacherSentCron,
            ActionEnum.ActionCourseAccessStudentInvite,
            ActionEnum.ActionCoursePublishedNewLesson,
            ActionEnum.ActionCourseAccessStudentNewLesson,
            ActionEnum.ActionCourseAccessStudentNewStep,
        ].includes(notificationAction)) {
            return 'notifications/status/add-circle';
        }
        if ([
            ActionEnum.ActionBillingSchoolRequisitesAccepted,
            ActionEnum.ActionBillingSchoolRequisitesDeclined,
            ActionEnum.ActionAffiliateRequisitesAccepted,
            ActionEnum.ActionAffiliateRequisitesDeclined,
        ].includes(notificationAction)) {
            return 'notifications/status/check-flower';
        }
        if ([
            ActionEnum.ActionBillingWithdrawDecline,
            ActionEnum.ActionCourseAccessStudentExpel,
            ActionEnum.ActionCourseAccessStudentAccessEnd,
            ActionEnum.ActionCourseAccessStudentAccessEnd_3Days,
            ActionEnum.ActionAffiliateWithdrawDeclined,
        ].includes(notificationAction)) {
            return 'notifications/status/cross-circle';
        }
        if (notificationAction === ActionEnum.ActionChatStudentWaitAnswer_24Hour) {
            return 'notifications/status/comment';
        }
        if ([
            ActionEnum.ActionBillingWithdrawAccepted,
            ActionEnum.ActionAffiliateWithdrawAccepted,
            ActionEnum.ActionStudentExportStudentList,
            ActionEnum.ActionStudentExportStudentProgress
        ].includes(notificationAction)) {
            return 'notifications/status/arrow-circle';
        }
        if (notificationAction === ActionEnum.ActionCourseStudentFinishCourse) {
            return 'notifications/status/check-circle';
        }
        if (notificationAction === ActionEnum.ActionBillingStudentPaidCourse) {
            return 'notifications/main/credit-card';
        }
    });
    var statusIconColor = computed(function () {
        if ([
            ActionEnum.ActionCoursePublishedNewLesson,
            ActionEnum.ActionHomeworkStudentSent,
            ActionEnum.ActionHomeworksStudentsSentCron,
            ActionEnum.ActionHomeworkTeacherSent,
            ActionEnum.ActionHomeworksTeacherSentCron,
            ActionEnum.ActionCourseAccessStudentInvite,
            ActionEnum.ActionBillingSchoolRequisitesAccepted,
            ActionEnum.ActionCourseAccessStudentNewLesson,
            ActionEnum.ActionCourseAccessStudentNewStep,
            ActionEnum.ActionAffiliateRequisitesAccepted,
            ActionEnum.ActionStudentExportStudentList,
            ActionEnum.ActionStudentExportStudentProgress
        ].includes(notificationAction)) {
            return 'blue';
        }
        if ([
            ActionEnum.ActionCourseAccessStudentExpel,
            ActionEnum.ActionBillingWithdrawDecline,
            ActionEnum.ActionBillingSchoolRequisitesDeclined,
            ActionEnum.ActionCourseAccessStudentAccessEnd,
            ActionEnum.ActionAffiliateRequisitesDeclined,
            ActionEnum.ActionAffiliateWithdrawDeclined,
        ].includes(notificationAction)) {
            return 'red';
        }
        if ([
            ActionEnum.ActionCourseStudentFinishCourse,
            ActionEnum.ActionBillingWithdrawAccepted,
            ActionEnum.ActionChatStudentWaitAnswer_24Hour,
            ActionEnum.ActionBillingStudentPaidCourse,
            ActionEnum.ActionAffiliateWithdrawAccepted,
        ].includes(notificationAction)) {
            return 'green';
        }
        if (notificationAction === ActionEnum.ActionCourseAccessStudentAccessEnd_3Days) {
            return 'orange';
        }
    });
    var statusIconClass = computed(function () {
        if (!statusIconColor.value)
            return '';
        return {
            green: 'text-green',
            orange: 'text-orange',
            red: 'text-red-500',
            blue: 'text-[#2AABEE]',
            white: 'text-white',
        }[statusIconColor.value];
    });
    return {
        statusIcon: statusIcon,
        statusIconClass: statusIconClass
    };
};
